export default __webpack_public_path__ + "static/media/Background 5_00011.a5d9ffc5.png";